import * as React from 'react';



export default class calenderIcon extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg viewBox="0 0 16 16" className={this.props.className} onClick={this.props.onClick}>
            <g id="icons/calendar" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="Group-44" stroke="#878787">
                    <g id="Calendar" transform="translate(1.000000, 1.000000)">
                        <polygon id="Stroke-2" points="0.502564103 13.3791754 13.425641 13.3791754 13.425641 1.53302154 0.502564103 1.53302154"></polygon>
                        <path d="M0.502162051,5.35401641 L12.7753518,5.35401641" id="Stroke-4"></path>
                        <g id="Holder" transform="translate(4.307692, 0.282642)">
                            <path d="M0.613515897,0.219922051 L0.613515897,2.24626051" id="Stroke-5"></path>
                            <path d="M5.63915692,0.219922051 L5.63915692,2.24626051" id="Stroke-6"></path>
                        </g>
                        <g id="Dates-row-1" transform="translate(2.153846, 7.538462)">
                            <path d="M0.618699487,0.443161026 L1.59467897,0.443161026" id="Stroke-8"></path>
                            <path d="M4.4321559,0.443161026 L5.40914051,0.443161026" id="Stroke-9"></path>
                            <path d="M8.45266872,0.443161026 L9.42965333,0.443161026" id="Stroke-12"></path>
                        </g>
                        <g id="Dates-row-2" transform="translate(2.153846, 10.769231)">
                            <path d="M0.618699487,0.22777641 L1.59467897,0.22777641" id="Stroke-10"></path>
                            <path d="M4.4321559,0.22777641 L5.40914051,0.22777641" id="Stroke-11"></path>
                            <path d="M8.45266872,0.22777641 L9.42965333,0.22777641" id="Stroke-13"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
  }
}
